import React, { useEffect, useState } from "react";
import { AlertTriangle, Phone, Menu, X } from "lucide-react";
import RhinoLogo from "./RhinoLogo";
import { businessInfo, navLinks } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* Alert bar */}
      <div className="bg-[#E11D26] text-white text-[13px] sm:text-sm">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center flex-wrap">
          <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={2.5} />
          <span className="font-semibold tracking-wide">
            FLORIDA HOMEOWNERS: INSURANCE CLAIM DEADLINES ARE STRICT — CALL NOW
          </span>
          <span className="hidden sm:inline">OR</span>
          <a href="/#contact" className="underline font-bold hidden sm:inline">
            GET A FREE REVIEW
          </a>
          <span className="hidden sm:inline">-</span>
          <a
            href={`tel:${businessInfo.phoneRaw}`}
            className="font-bold underline flex items-center gap-1"
          >
            <Phone className="h-3.5 w-3.5" /> {businessInfo.phone}
          </a>
        </div>
      </div>

      {/* Nav */}
      <div
        className={`bg-black border-b border-white/5 transition-shadow ${
          scrolled ? "shadow-[0_10px_30px_rgba(0,0,0,0.5)]" : ""
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <RhinoLogo />

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-[#E11D26] hover:text-white text-sm font-bold tracking-wider uppercase transition-colors"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:${businessInfo.phoneRaw}`}
              className="flex items-center gap-2 text-white hover:text-[#E11D26] text-sm font-bold transition-colors"
            >
              <Phone className="h-4 w-4" />
              {businessInfo.phone}
            </a>
          </div>

          <button
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-white"
          >
            {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>

        {/* Mobile nav */}
        {open && (
          <div className="lg:hidden bg-black border-t border-white/10">
            <div className="px-4 py-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="text-[#E11D26] font-bold tracking-wider uppercase py-1"
                >
                  {link.label}
                </a>
              ))}
              <a
                href={`tel:${businessInfo.phoneRaw}`}
                className="text-white font-bold py-1 flex items-center gap-2"
              >
                <Phone className="h-4 w-4" /> {businessInfo.phone}
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
